module.exports = __webpack_public_path__ + "static/media/aw2.9aae93d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/aw2.png
// module id = 1366
// module chunks = 0